module.exports = __webpack_public_path__ + "img/bg.7e6dfad9.png";